var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconComment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 6.34375H11V7.65625H5V6.34375ZM11 3.65625H3V5H11V3.65625ZM13.6562 1.65625V13.6562L11 11H1.65625C1.30208 11 0.989583 10.875 0.71875 10.625C0.46875 10.3542 0.34375 10.0312 0.34375 9.65625V1.65625C0.34375 1.30208 0.46875 1 0.71875 0.75C0.989583 0.479167 1.30208 0.34375 1.65625 0.34375H12.3438C12.6979 0.34375 13 0.479167 13.25 0.75C13.5208 1 13.6562 1.30208 13.6562 1.65625ZM12.3438 1.65625H1.65625V9.65625H11.5625L12.3438 10.4375V1.65625Z",
    fill: "current",
    fillOpacity: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconComment);
export default __webpack_public_path__ + "static/media/icon-comment.f93bdfa64e259d38ae9c721f203c2189.svg";
export { ForwardRef as ReactComponent };